<template>
    <v-card>
        <v-card-title>
            <span class="text-h6 mobile-text-f16">Choose Snowboard Type</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('modal-close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-container class="p-4">
            <div class="mobile-block">
                <v-row class="border-top border-bottom">
                    <v-col cols="6" md="4">
                        <h5 class="mobile-text-f16">Renter Name</h5>
                    </v-col>
                    <v-col cols="6" md="8" class="text-right">
                        <h5 class="mobile-text-f16">{{customer_name}}</h5>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4" class="border-bottom">
                        <h5 class="mobile-text-f16">Snowboard Type</h5>
                    </v-col>
                    <v-col cols="12" md="8" class="text-right">
                        <v-radio-group row v-model="snowboard_type" class="mt-0">
                            <v-radio v-for="type in resources.snowboard_types"
                                     :value="type.value"
                                     :label="type.name"
                                     :key="'radio__snowboard_type_'+type.value"
                                     :column="false"
                                     class="justify-content-end mobile-text-f16"
                            >

                            </v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </div>
            <div class="desktop-block">
                <v-row class="border-top border-bottom">
                    <v-col cols="6" md="4">
                        <h5 class="mobile-text-f16">Renter Name</h5>
                    </v-col>
                    <v-col cols="6" md="8" class="text-right">
                        <h5 class="mobile-text-f16">Snowboard Type</h5>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" md="4">
                        <h5 class="mobile-text-f16">{{customer_name}}</h5>
                    </v-col>
                    <v-col cols="6" md="8" class="text-right">
                        <v-radio-group row v-model="snowboard_type" class="mt-0">
                            <v-radio v-for="type in resources.snowboard_types"
                                     :value="type.value"
                                     :label="type.name"
                                     :key="'radio__snowboard_type_'+type.value"
                                     :column="false"
                                     class="justify-content-end mobile-text-f16"
                            >

                            </v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </div>
            <v-spacer></v-spacer>
            <v-row class="justify-content-end">
                <v-btn text @click="skip">Skip</v-btn>
                <v-btn color="primary" text @click="saveSnowboardType">Continue</v-btn>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>

export default {
    name: "DialogSnowboardType",
    props     : ['modalId'],
    data    : () => ({
        snowboard_type : "regular",
    }),
    computed: {
        resources() {
            return this.$store.state.resources;
        },
        customer_name() {
            return this.$store.state.ui.modalsState[this.modalId].customer_name;
        }
    },
    methods   : {
        async skip(){
            this.$emit('modal-close');
        },
        async saveSnowboardType() {
            this.$store.commit('set_model_value',{path:'ui.modalsState['+this.modalId+'].snowboard_type', value: this.snowboard_type})
            this.$emit('modal-close');
        },
    }
}
</script>

<style scoped>

    @media (max-width: 575.98px) {
        .mobile-text-f16{
            font-size: 16px !important;
        }
        .desktop-block{
            display: none;
        }
        .mobile-block{
            display: block;
        }
    }

    @media (min-width: 576px){
        .mobile-block{
            display: none;
        }
        .desktop-block{
            display: block;
        }
    }

</style>
